export const meiEluththukkal = ['க்','ங்','ச்','ஞ்','ட்','ண்','த்','ந்','ப்','ம்','ய்','ர்','ல்','வ்','ழ்','ள்','ற்','ன்'];

export const uyireEluththukkal = ['அ','ஆ','இ','ஈ','உ','ஊ','எ','ஏ','ஐ','ஒ','ஓ','ஔ'];

export const keyBoardRightSideUyireMeiLetters = ['க', 'ங', 'ச', 'ஞ', 'ட', 'ண', 'த', 'ந', 'ப', 'ம', 'ய', 'ர', 'ல', 'வ', 'ழ', 'ள', 'ற', 'ன'];

export const meiLettersCombo : {[key: string]: any} = {
    'க்'    : 'க',
    'ங்'   : 'ங',
    'ச்'    : 'ச',
    'ஞ்'   : 'ஞ',
    'ட்'   : 'ட',
    'ண்'   : 'ண',
    'த்'   : 'த',
    'ந்'   : 'ந',
    'ப்'   : 'ப',
    'ம்'   : 'ம',
    'ய்'   : 'ய',
    'ர்'    : 'ர',
    'ல்'    : 'ல',
    'வ்'    : 'வ',
    'ழ்'    : 'ழ',
    'ள்'    : 'ள',
    'ற்'    : 'ற',
    'ன்'    : 'ன',
};

export const uyireMeiCombo : { [key: string]: any } =  {
    'க'    : ['க்', 'அ'],
    'கா'   : ['க்', 'ஆ'],
    'கி'    : ['க்', 'இ'],
    'கீ'    : ['க்', 'ஈ'],
    'கு'    : ['க்', 'உ'],
    'கூ'    : ['க்', 'ஊ'],
    'கெ'   : ['க்', 'எ'],
    'கே'   : ['க்', 'ஏ'],
    'கை'   : ['க்', 'ஐ'],
    'கொ'   : ['க்', 'ஒ'],
    'கோ'   : ['க்', 'ஓ'],
    'கௌ'  : ['க்', 'ஔ'],

    'ங'    : ['ங்', 'அ'],
    'ஙா'   : ['ங்', 'ஆ'],
    'ஙி'    : ['ங்', 'இ'],
    'ஙீ'    : ['ங்', 'ஈ'],
    'ஙு'    : ['ங்', 'உ'],
    'ஙூ'    : ['ங்', 'ஊ'],
    'ஙெ'   : ['ங்', 'எ'],
    'ஙே'   : ['ங்', 'ஏ'],
    'ஙை'   : ['ங்', 'ஐ'],
    'ஙொ'   : ['ங்', 'ஒ'],
    'ஙோ'   : ['ங்', 'ஓ'],
    'ஙௌ'  : ['ங்', 'ஔ'],

    'ச'    : ['ச்', 'அ'],
    'சா'   : ['ச்', 'ஆ'],
    'சி'    : ['ச்', 'இ'],
    'சீ'    : ['ச்', 'ஈ'],
    'சு'    : ['ச்', 'உ'],
    'சூ'    : ['ச்', 'ஊ'],
    'செ'   : ['ச்', 'எ'],
    'சே'   : ['ச்', 'ஏ'],
    'சை'   : ['ச்', 'ஐ'],
    'சொ'   : ['ச்', 'ஒ'],
    'சோ'   : ['ச்', 'ஓ'],
    'சௌ'  : ['ச்', 'ஔ'],

    'ஞ'    : ['ஞ்', 'அ'],
    'ஞா'   : ['ஞ்', 'ஆ'],
    'ஞி'    : ['ஞ்', 'இ'],
    'ஞீ'    : ['ஞ்', 'ஈ'],
    'ஞு'    : ['ஞ்', 'உ'],
    'ஞூ'    : ['ஞ்', 'ஊ'],
    'ஞெ'   : ['ஞ்', 'எ'],
    'ஞே'   : ['ஞ்', 'ஏ'],
    'ஞை'   : ['ஞ்', 'ஐ'],
    'ஞொ'   : ['ஞ்', 'ஒ'],
    'ஞோ'   : ['ஞ்', 'ஓ'],
    'ஞௌ'  : ['ஞ்', 'ஔ'],

    'ட'    : ['ட்', 'அ'],
    'டா'   : ['ட்', 'ஆ'],
    'டி'    : ['ட்', 'இ'],
    'டீ'    : ['ட்', 'ஈ'],
    'டு'    : ['ட்', 'உ'],
    'டூ'    : ['ட்', 'ஊ'],
    'டெ'   : ['ட்', 'எ'],
    'டே'   : ['ட்', 'ஏ'],
    'டை'   : ['ட்', 'ஐ'],
    'டொ'   : ['ட்', 'ஒ'],
    'டோ'   : ['ட்', 'ஓ'],
    'டௌ'  : ['ட்', 'ஔ'],

    'ண'    : ['ண்', 'அ'],
    'ணா'   : ['ண்', 'ஆ'],
    'ணி'    : ['ண்', 'இ'],
    'ணீ'    : ['ண்', 'ஈ'],
    'ணு'    : ['ண்', 'உ'],
    'ணூ'    : ['ண்', 'ஊ'],
    'ணெ'   : ['ண்', 'எ'],
    'ணே'   : ['ண்', 'ஏ'],
    'ணை'   : ['ண்', 'ஐ'],
    'ணொ'   : ['ண்', 'ஒ'],
    'ணோ'   : ['ண்', 'ஓ'],
    'ணௌ'  : ['ண்', 'ஔ'],

    'த'    : ['த்', 'அ'],
    'தா'   : ['த்', 'ஆ'],
    'தி'    : ['த்', 'இ'],
    'தீ'    : ['த்', 'ஈ'],
    'து'    : ['த்', 'உ'],
    'தூ'    : ['த்', 'ஊ'],
    'தெ'   : ['த்', 'எ'],
    'தே'   : ['த்', 'ஏ'],
    'தை'   : ['த்', 'ஐ'],
    'தொ'   : ['த்', 'ஒ'],
    'தோ'   : ['த்', 'ஓ'],
    'தௌ'  : ['த்', 'ஔ'],

    'ந'    : ['ந்', 'அ'],
    'நா'   : ['ந்', 'ஆ'],
    'நி'    : ['ந்', 'இ'],
    'நீ'    : ['ந்', 'ஈ'],
    'நு'    : ['ந்', 'உ'],
    'நூ'    : ['ந்', 'ஊ'],
    'நெ'   : ['ந்', 'எ'],
    'நே'   : ['ந்', 'ஏ'],
    'நை'   : ['ந்', 'ஐ'],
    'நொ'   : ['ந்', 'ஒ'],
    'நோ'   : ['ந்', 'ஓ'],
    'நௌ'  : ['ந்', 'ஔ'],

    'ப'    : ['ப்', 'அ'],
    'பா'   : ['ப்', 'ஆ'],
    'பி'    : ['ப்', 'இ'],
    'பீ'    : ['ப்', 'ஈ'],
    'பு'    : ['ப்', 'உ'],
    'பூ'    : ['ப்', 'ஊ'],
    'பெ'   : ['ப்', 'எ'],
    'பே'   : ['ப்', 'ஏ'],
    'பை'   : ['ப்', 'ஐ'],
    'பொ'   : ['ப்', 'ஒ'],
    'போ'   : ['ப்', 'ஓ'],
    'பௌ'  : ['ப்', 'ஔ'],

    'ம'    : ['ம்', 'அ'],
    'மா'   : ['ம்', 'ஆ'],
    'மி'    : ['ம்', 'இ'],
    'மீ'    : ['ம்', 'ஈ'],
    'மு'    : ['ம்', 'உ'],
    'மூ'    : ['ம்', 'ஊ'],
    'மெ'   : ['ம்', 'எ'],
    'மே'   : ['ம்', 'ஏ'],
    'மை'   : ['ம்', 'ஐ'],
    'மொ'   : ['ம்', 'ஒ'],
    'மோ'   : ['ம்', 'ஓ'],
    'மௌ'  : ['ம்', 'ஔ'],

    'ய'    : ['ய்', 'அ'],
    'யா'   : ['ய்', 'ஆ'],
    'யி'    : ['ய்', 'இ'],
    'யீ'    : ['ய்', 'ஈ'],
    'யு'    : ['ய்', 'உ'],
    'யூ'    : ['ய்', 'ஊ'],
    'யெ'   : ['ய்', 'எ'],
    'யே'   : ['ய்', 'ஏ'],
    'யை'   : ['ய்', 'ஐ'],
    'யொ'   : ['ய்', 'ஒ'],
    'யோ'   : ['ய்', 'ஓ'],
    'யௌ'  : ['ய்', 'ஔ'],

    'ர'    : ['ர்', 'அ'],
    'ரா'   : ['ர்', 'ஆ'],
    'ரி'    : ['ர்', 'இ'],
    'ரீ'    : ['ர்', 'ஈ'],
    'ரு'    : ['ர்', 'உ'],
    'ரூ'    : ['ர்', 'ஊ'],
    'ரெ'   : ['ர்', 'எ'],
    'ரே'   : ['ர்', 'ஏ'],
    'ரை'   : ['ர்', 'ஐ'],
    'ரொ'   : ['ர்', 'ஒ'],
    'ரோ'   : ['ர்', 'ஓ'],
    'ரௌ'  : ['ர்', 'ஔ'],

    'ல'    : ['ல்', 'அ'],
    'லா'   : ['ல்', 'ஆ'],
    'லி'    : ['ல்', 'இ'],
    'லீ'    : ['ல்', 'ஈ'],
    'லு'    : ['ல்', 'உ'],
    'லூ'    : ['ல்', 'ஊ'],
    'லெ'   : ['ல்', 'எ'],
    'லே'   : ['ல்', 'ஏ'],
    'லை'   : ['ல்', 'ஐ'],
    'லொ'   : ['ல்', 'ஒ'],
    'லோ'   : ['ல்', 'ஓ'],
    'லௌ'  : ['ல்', 'ஔ'],

    'வ'    : ['வ்', 'அ'],
    'வா'   : ['வ்', 'ஆ'],
    'வி'    : ['வ்', 'இ'],
    'வீ'    : ['வ்', 'ஈ'],
    'வு'    : ['வ்', 'உ'],
    'வூ'    : ['வ்', 'ஊ'],
    'வெ'   : ['வ்', 'எ'],
    'வே'   : ['வ்', 'ஏ'],
    'வை'   : ['வ்', 'ஐ'],
    'வொ'   : ['வ்', 'ஒ'],
    'வோ'   : ['வ்', 'ஓ'],
    'வௌ'  : ['வ்', 'ஔ'],

    'ழ'    : ['ழ்', 'அ'],
    'ழா'   : ['ழ்', 'ஆ'],
    'ழி'    : ['ழ்', 'இ'],
    'ழீ'    : ['ழ்', 'ஈ'],
    'ழு'    : ['ழ்', 'உ'],
    'ழூ'    : ['ழ்', 'ஊ'],
    'ழெ'   : ['ழ்', 'எ'],
    'ழே'   : ['ழ்', 'ஏ'],
    'ழை'   : ['ழ்', 'ஐ'],
    'ழொ'   : ['ழ்', 'ஒ'],
    'ழோ'   : ['ழ்', 'ஓ'],
    'ழௌ'  : ['ழ்', 'ஔ'],

    'ள'    : ['ள்', 'அ'],
    'ளா'   : ['ள்', 'ஆ'],
    'ளி'    : ['ள்', 'இ'],
    'ளீ'    : ['ள்', 'ஈ'],
    'ளு'    : ['ள்', 'உ'],
    'ளூ'    : ['ள்', 'ஊ'],
    'ளெ'   : ['ள்', 'எ'],
    'ளே'   : ['ள்', 'ஏ'],
    'ளை'   : ['ள்', 'ஐ'],
    'ளொ'   : ['ள்', 'ஒ'],
    'ளோ'   : ['ள்', 'ஓ'],
    'ளௌ'  : ['ள்', 'ஔ'],

    'ற'    : ['ற்', 'அ'],
    'றா'   : ['ற்', 'ஆ'],
    'றி'    : ['ற்', 'இ'],
    'றீ'    : ['ற்', 'ஈ'],
    'று'    : ['ற்', 'உ'],
    'றூ'    : ['ற்', 'ஊ'],
    'றெ'   : ['ற்', 'எ'],
    'றே'   : ['ற்', 'ஏ'],
    'றை'   : ['ற்', 'ஐ'],
    'றொ'   : ['ற்', 'ஒ'],
    'றோ'   : ['ற்', 'ஓ'],
    'றௌ'  : ['ற்', 'ஔ'],

    'ன'    : ['ன்', 'அ'],
    'னா'   : ['ன்', 'ஆ'],
    'னி'    : ['ன்', 'இ'],
    'னீ'    : ['ன்', 'ஈ'],
    'னு'    : ['ன்', 'உ'],
    'னூ'    : ['ன்', 'ஊ'],
    'னெ'   : ['ன்', 'எ'],
    'னே'   : ['ன்', 'ஏ'],
    'னை'   : ['ன்', 'ஐ'],
    'னொ'   : ['ன்', 'ஒ'],
    'னோ'   : ['ன்', 'ஓ'],
    'னௌ'  : ['ன்', 'ஔ'],
};